module.exports = '4.8.0';



// WEBPACK FOOTER //
// ./src/version.js